import React from 'react';
import App from 'App';
import paths, { rootPaths } from './paths';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import ProtectedChildren from '../providers/ProtectedChildren';

import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import WizardAuth from 'components/authentication/wizard/WizardAuth';
import Landing from 'components/pages/landing/Landing';
import Accordion from 'components/doc-components/Accordion';
import Alerts from 'components/doc-components/Alerts';
import Badges from 'components/doc-components/Badges';
import Breadcrumbs from 'components/doc-components/Breadcrumb';
import Buttons from 'components/doc-components/Buttons';
import CalendarExample from 'components/doc-components/CalendarExample';
import Cards from 'components/doc-components/Cards';
import Dropdowns from 'components/doc-components/Dropdowns';
import ListGroups from 'components/doc-components/ListGroups';
import Modals from 'components/doc-components/Modals';
import Offcanvas from 'components/doc-components/Offcanvas';
import Pagination from 'components/doc-components/Pagination';
import BasicProgressBar from 'components/doc-components/ProgressBar';
import Spinners from 'components/doc-components/Spinners';
import Toasts from 'components/doc-components/Toasts';
import Avatar from 'components/doc-components/Avatar';
import Image from 'components/doc-components/Image';
import Tooltips from 'components/doc-components/Tooltips';
import Popovers from 'components/doc-components/Popovers';
import Figures from 'components/doc-components/Figures';
import Hoverbox from 'components/doc-components/Hoverbox';
import Tables from 'components/doc-components/Tables';
import FormControl from 'components/doc-components/FormControl';
import InputGroup from 'components/doc-components/InputGroup';
import Select from 'components/doc-components/Select';
import Checks from 'components/doc-components/Checks';
import Range from 'components/doc-components/Range';
import FormLayout from 'components/doc-components/FormLayout';
import FloatingLabels from 'components/doc-components/FloatingLabels';
import FormValidation from 'components/doc-components/FormValidation';
import BootstrapCarousel from 'components/doc-components/BootstrapCarousel';
import SlickCarousel from 'components/doc-components/SlickCarousel';
import Navs from 'components/doc-components/Navs';
import Navbars from 'components/doc-components/Navbars';
import Tabs from 'components/doc-components/Tabs';
import Collapse from 'components/doc-components/Collapse';
import CountUp from 'components/doc-components/CountUp';
import Embed from 'components/doc-components/Embed';
import Backgrounds from 'components/doc-components/Backgrounds';
import Search from 'components/doc-components/Search';
import VerticalNavbar from 'components/doc-components/VerticalNavbar';
import NavBarTop from 'components/doc-components/NavBarTop';
import NavbarDoubleTop from 'components/doc-components/NavbarDoubleTop';
import ComboNavbar from 'components/doc-components/ComboNavbar';
import TypedText from 'components/doc-components/TypedText';
import FileUploader from 'components/doc-components/FileUploader';
import Borders from 'components/utilities/Borders';
import Colors from 'components/utilities/Colors';
import Background from 'components/utilities/Background';
import ColoredLinks from 'components/utilities/ColoredLinks';
import Display from 'components/utilities/Display';
import Visibility from 'components/utilities/Visibility';
import StretchedLink from 'components/utilities/StretchedLink';
import Float from 'components/utilities/Float';
import Position from 'components/utilities/Position';
import Spacing from 'components/utilities/Spacing';
import Sizing from 'components/utilities/Sizing';
import TextTruncation from 'components/utilities/TextTruncation';
import Typography from 'components/utilities/Typography';
import VerticalAlign from 'components/utilities/VerticalAlign';
import Flex from 'components/utilities/Flex';
import Grid from 'components/utilities/Grid';
import WizardForms from 'components/doc-components/WizardForms';
import GettingStarted from 'components/documentation/GettingStarted';
import Configuration from 'components/documentation/Configuration';
import DarkMode from 'components/documentation/DarkMode';
import Plugins from 'components/documentation/Plugins';
import Styling from 'components/documentation/Styling';
import DesignFile from 'components/documentation/DesignFile';
import Starter from 'components/pages/Starter';
import AnimatedIcons from 'components/doc-components/AnimatedIcons';
import DatePicker from 'components/doc-components/DatePicker';
import FontAwesome from 'components/doc-components/FontAwesome';
import Changelog from 'components/documentation/change-log/ChangeLog';
import Analytics from 'components/dashboards/analytics';
import Crm from 'components/dashboards/crm';
import Saas from 'components/dashboards/saas';
import Profile from 'components/pages/user/profile/Profile';
import Associations from 'components/pages/asscociations/Associations';
import Followers from 'components/app/social/followers/Followers';
import Notifications from 'components/app/social/notifications/Notifications';
import ActivityLog from 'components/app/social/activity-log/ActivityLog';
import Settings from 'components/pages/user/settings/Settings';
import Feed from 'components/app/social/feed/Feed';
import Placeholder from 'components/doc-components/Placeholder';
import Lightbox from 'components/doc-components/Lightbox';
import AdvanceTableExamples from 'components/doc-components/AdvanceTableExamples';
import Calendar from 'components/app/calendar/Calendar';
import FaqAlt from 'components/pages/faq/faq-alt/FaqAlt';
import FaqBasic from 'components/pages/faq/faq-basic/FaqBasic';
import FaqAccordion from 'components/pages/faq/faq-accordion/FaqAccordion';
import PrivacyPolicy from 'components/pages/miscellaneous/privacy-policy/PrivacyPolicy';
import InvitePeople from 'components/pages/miscellaneous/invite-people/InvitePeople';
import PricingDefault from 'components/pages/pricing/pricing-default/PricingDefault';
import PricingAlt from 'components/pages/pricing/pricing-alt/PricingAlt';
import Invoice from 'components/app/e-commerce/Invoice';
import Billing from 'components/app/e-commerce/billing/Billing';
import Checkout from 'components/app/e-commerce/checkout/Checkout';
import ShoppingCart from 'components/app/e-commerce/cart/ShoppingCart';
import CustomersDetails from 'components/app/e-commerce/customers-details/CustomersDetails';
import OrderDetails from 'components/app/e-commerce/orders/order-details/OrderDetails';
import Products from 'components/app/e-commerce/product/Products';
import ProductDetails from 'components/app/e-commerce/product/product-details/ProductDetails';
import AddProduct from 'components/app/e-commerce/product/add-product/AddProduct';
import Orders from 'components/app/e-commerce/orders/order-list/Orders';
import Customers from 'components/app/e-commerce/customers/Customers';
import Courses from 'components/app/e-learning/course/Courses';
import CourseDetails from 'components/app/e-learning/course/course-details';
import CreateCourse from 'components/app/e-learning/course/create-a-course';
import TrainerProfile from 'components/app/e-learning/trainer-profile';
import StudentOverview from 'components/app/e-learning/student-overview';
import CreateEvent from 'components/app/events/create-an-event/CreateEvent';
import EventList from 'components/app/events/event-list/EventList';
import EventDetail from 'components/app/events/event-detail/EventDetail';
import EmailDetail from 'components/app/email/email-detail/EmailDetail';
import Compose from 'components/app/email/compose/Compose';
import Inbox from 'components/app/email/inbox/Inbox';
import Rating from 'components/doc-components/Rating';
import AdvanceSelect from 'components/doc-components/AdvanceSelect';
import Editor from 'components/doc-components/Editor';
import Chat from 'components/app/chat/Chat';
import Kanban from 'components/app/kanban/Kanban';
import DraggableExample from 'components/doc-components/DraggableExample';
import LineCharts from 'components/doc-components/charts-example/echarts/line-charts';
import BarCharts from 'components/doc-components/charts-example/echarts/bar-charts';
import CandlestickCharts from 'components/doc-components/charts-example/echarts/candlestick-charts';
import GeoMaps from 'components/doc-components/charts-example/echarts/geo-map';
import ScatterCharts from 'components/doc-components/charts-example/echarts/scatter-charts';
import PieCharts from 'components/doc-components/charts-example/echarts/pie-charts';
import RadarCharts from 'components/doc-components/charts-example/echarts/radar-charts/Index';
import HeatmapCharts from 'components/doc-components/charts-example/echarts/heatmap-chart';
import Chartjs from 'components/doc-components/charts-example/chartjs';
import D3js from 'components/doc-components/charts-example/d3';
import HowToUse from 'components/doc-components/charts-example/echarts/HowToUse';
import GoogleMapExample from 'components/doc-components/GoogleMapExample';
import LeafletMapExample from 'components/doc-components/LeafletMapExample';
import CookieNoticeExample from 'components/doc-components/CookieNoticeExample';
import Scrollbar from 'components/doc-components/Scrollbar';
import Scrollspy from 'components/doc-components/Scrollspy';
import ReactIcons from 'components/doc-components/ReactIcons';
import ReactPlayerExample from 'components/doc-components/ReactPlayerExample';
import EmojiMartExample from 'components/doc-components/EmojiMart';
import TreeviewExample from 'components/doc-components/TreeviewExample';
import Timeline from 'components/doc-components/Timeline';
import Widgets from 'widgets/Widgets';
import Ecommerce from 'components/dashboards/e-commerce';
import Lms from 'components/dashboards/lms';
import ProjectManagement from 'components/dashboards/project-management';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import SimpleLogin from 'components/authentication/simple/Login';
import SimpleLogout from 'components/authentication/simple/Logout';
import SimpleRegistration from 'components/authentication/simple/Registration';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';
import SimpleLockScreen from 'components/authentication/simple/LockScreen';
import CardLogin from 'components/authentication/card/Login';
import CardLogout from 'components/authentication/card/Logout';
import CardRegistration from 'components/authentication/card/Registration';
import CardForgetPassword from 'components/authentication/card/ForgetPassword';
import CardConfirmMail from 'components/authentication/card/ConfirmMail';
import CardPasswordReset from 'components/authentication/card/PasswordReset';
import CardLockScreen from 'components/authentication/card/LockScreen';
import SplitLogin from 'components/authentication/split/Login';
import SplitLogout from 'components/authentication/split/Logout';
import SplitRegistration from 'components/authentication/split/Registration';
import SplitForgetPassword from 'components/authentication/split/ForgetPassword';
import SplitPasswordReset from 'components/authentication/split/PasswordReset';
import SplitConfirmMail from 'components/authentication/split/ConfirmMail';
import SplitLockScreen from 'components/authentication/split/LockScreen';
import Dashboard from 'components/dashboards/default';
import Faq from 'components/documentation/Faq';
import SupportDesk from 'components/dashboards/support-desk';
import TableView from 'components/app/support-desk/tickets-layout/TableView';
import CardView from 'components/app/support-desk/tickets-layout/CardView';
import Contacts from 'components/app/support-desk/contacts/Contacts';
import ContactDetails from 'components/app/support-desk/contact-details/ContactDetails';
import TicketsPreview from 'components/app/support-desk/tickets-preview/TicketsPreview';
import QuickLinks from 'components/app/support-desk/quick-links/QuickLinks';
import Reports from 'components/app/support-desk/reports/Reports';
import InputMaskExample from 'components/doc-components/InputMaskExample';
import RangeSlider from 'components/doc-components/RangeSlider';
import VerticalNavLayout from 'layouts/VerticalNavLayout';
import TopNavLayout from 'layouts/TopNavLayout';
import ComboNavLayout from 'layouts/ComboNavLayout';
import DoubleTopNavLayout from 'layouts/DoubleTopNavLayout';
import Caisse from 'components/pages/caisse/caisse';
import Facturation from 'components/pages/facturation/facturation';
import Achat from 'components/pages/achats/achat';
import AchatFormulaire from 'components/pages/achats/achatFormulaire';
import ProduitsServices from 'components/pages/fiches/produitsServices/Produits';
import DetailsProduit from 'components/pages/fiches/produitsServices/detailsProduit/DetailsProduit';
import Fournisseur from 'components/pages/fiches/Fournisseurs/Fournisseurs';
import DetailsFournisseur from 'components/pages/fiches/Fournisseurs/detailsFournisseur/DetailsFournisseur';
import Factures from 'components/pages/factures/factures';
import FactureInvoice from 'components/pages/factures/factureInvoice';
import TransfertsKanban from 'components/pages/transferts/kanban/transfertsKanban';
import Traites from 'components/pages/traites/traites';
import Recette from 'components/pages/recette/recette';
import Portefeuille from 'components/pages/portefeuille/portefeuille';
import Produits from 'components/pages/produits/produits';
import InventoryList from 'components/pages/inventory/inventoryList';
import GestionProduits from 'components/pages/Gestionproduits/GestionProduits';
import BonsAchat from 'components/pages/bons achat/bonAchat';
import SuiviFournisseur from 'components/pages/suiviFournisseur/SuiviFournisseur';

const routes = [
  {
    element: <App />,
    children: [
      {
        path: 'landing',
        element: <Landing />,
      },
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: rootPaths.authSimpleRoot,
            element: <AuthSimpleLayout />,
            children: [
              {
                path: paths.simpleLogin,
                element: (
                  <ProtectedChildren>
                    <SimpleLogin />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleRegister,
                element: (
                  <ProtectedChildren>
                    <SimpleRegistration />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleLogout,
                element: (
                  <ProtectedChildren>
                    <SimpleLogout />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleForgotPassword,
                element: (
                  <ProtectedChildren>
                    <SimpleForgetPassword />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleResetPassword,
                element: (
                  <ProtectedChildren>
                    <SimplePasswordReset />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleConfirmMail,
                element: (
                  <ProtectedChildren>
                    <SimpleConfirmMail />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.simpleLockScreen,
                element: (
                  <ProtectedChildren>
                    <SimpleLockScreen />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.authCardRoot,
            children: [
              {
                path: paths.cardLogin,
                element: <CardLogin />,
              },
              {
                path: paths.cardRegister,
                element: (
                  <ProtectedChildren>
                    <CardRegistration />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cardLogout,
                element: (
                  <ProtectedChildren>
                    <CardLogout />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cardForgotPassword,
                element: (
                  <ProtectedChildren>
                    <CardForgetPassword />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cardResetPassword,
                element: (
                  <ProtectedChildren>
                    <CardPasswordReset />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cardConfirmMail,
                element: (
                  <ProtectedChildren>
                    <CardConfirmMail />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cardLockScreen,
                element: (
                  <ProtectedChildren>
                    <CardLockScreen />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.authSplitRoot,
            children: [
              {
                path: paths.splitLogin,
                element: (
                  <ProtectedChildren>
                    <SplitLogin />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitRegister,
                element: (
                  <ProtectedChildren>
                    <SplitRegistration />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitLogout,
                element: (
                  <ProtectedChildren>
                    <SplitLogout />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitForgotPassword,
                element: (
                  <ProtectedChildren>
                    <SplitForgetPassword />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitResetPassword,
                element: (
                  <ProtectedChildren>
                    <SplitPasswordReset />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitConfirmMail,
                element: (
                  <ProtectedChildren>
                    <SplitConfirmMail />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.splitLockScreen,
                element: (
                  <ProtectedChildren>
                    <SplitLockScreen />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: paths.authWizard,
            element: (
              <ProtectedChildren>
                <WizardAuth />
              </ProtectedChildren>
            ),
          },
        ],
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: (
              <ProtectedChildren>
                <Dashboard />
              </ProtectedChildren>
            ),
          },
          {
            path: rootPaths.dashboardRoot,
            children: [
              {
                path: paths.analytics,
                element: (
                  <ProtectedChildren>
                    <Analytics />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.caisse,
                element: (
                  <ProtectedChildren>
                    <Caisse />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.facturation,
                element: (
                  <ProtectedChildren path={paths.facturation}>
                    <Facturation />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.factures,
                element: (
                  <ProtectedChildren path={paths.factures}>
                    <Factures />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.traites,
                element: (
                  <ProtectedChildren path={paths.traites}>
                    <Traites />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.recette,
                element: (
                  <ProtectedChildren path={paths.recette}>
                    <Recette />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.suiviFournisseur,
                element: (
                  <ProtectedChildren path={paths.suiviFournisseur}>
                    <SuiviFournisseur />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.produits,
                element: (
                  <ProtectedChildren path={paths.produits}>
                    <Produits />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.portefeuille,
                element: (
                  <ProtectedChildren path={paths.portefeuille}>
                    <Portefeuille />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.transferts,
                element: (
                  <ProtectedChildren path={paths.transferts}>
                    <TransfertsKanban />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.gestionProduits,
                element: (
                  <ProtectedChildren path={paths.gestionProduits}>
                    <GestionProduits />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.bonsAchat,
                element: (
                  <ProtectedChildren path={paths.bonsAchat}>
                    <BonsAchat />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.factureInvoice(':idFacture'),
                element: (
                  <ProtectedChildren>
                    <FactureInvoice />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.inventoryList,
                element: (
                  <ProtectedChildren>
                    <InventoryList />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.achat,
                element: (
                  <ProtectedChildren>
                    <Achat />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.formulaireAchat,
                element: (
                  <ProtectedChildren>
                    <AchatFormulaire />
                  </ProtectedChildren>
                ), // Use the correct component
              },
              {
                path: paths.detailsProduit(':idProduit'), // Correctly handle the dynamic parameter
                element: (
                  <ProtectedChildren>
                    <DetailsProduit />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.produitsServices,
                element: (
                  <ProtectedChildren>
                    <ProduitsServices />
                  </ProtectedChildren>
                ), // Use the correct component
              },
              {
                path: paths.formulaireFournisseur,
                element: (
                  <ProtectedChildren>
                    <AchatFormulaire />
                  </ProtectedChildren>
                ), // Use the correct component
              },
              {
                path: paths.detailsFournisseur(':idFounisseur'), // Correctly handle the dynamic parameter
                element: (
                  <ProtectedChildren>
                    <DetailsFournisseur />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.Fournisseurs,
                element: (
                  <ProtectedChildren>
                    <Fournisseur />
                  </ProtectedChildren>
                ), // Use the correct component
              },
              {
                path: paths.crm,
                element: (
                  <ProtectedChildren>
                    <Crm />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.saas,
                element: (
                  <ProtectedChildren>
                    <Saas />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.ecommerce,
                element: (
                  <ProtectedChildren>
                    <Ecommerce />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.lms,
                element: (
                  <ProtectedChildren>
                    <Lms />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.projectManagement,
                element: (
                  <ProtectedChildren>
                    <ProjectManagement />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.supportDesk,
                element: (
                  <ProtectedChildren>
                    <SupportDesk />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.appsRoot,
            children: [
              {
                path: paths.calendar,
                element: (
                  <ProtectedChildren>
                    <Calendar />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.chat,
                element: (
                  <ProtectedChildren>
                    <Chat />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.kanban,
                element: (
                  <ProtectedChildren>
                    <Kanban />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.emailRoot,
            children: [
              {
                path: paths.emailInbox,
                element: (
                  <ProtectedChildren>
                    <Inbox />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.emailDetail,
                element: (
                  <ProtectedChildren>
                    <EmailDetail />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.emailCompose,
                element: (
                  <ProtectedChildren>
                    <Compose />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.eventsRoot,
            children: [
              {
                path: paths.createEvent,
                element: (
                  <ProtectedChildren>
                    <CreateEvent />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.eventDetail,
                element: (
                  <ProtectedChildren>
                    <EventDetail />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.eventList,
                element: (
                  <ProtectedChildren>
                    <EventList />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.socialRoot,
            children: [
              {
                path: paths.feed,
                element: (
                  <ProtectedChildren>
                    <Feed />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.activityLog,
                element: (
                  <ProtectedChildren>
                    <ActivityLog />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.notifications,
                element: (
                  <ProtectedChildren>
                    <Notifications />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.followers,
                element: (
                  <ProtectedChildren>
                    <Followers />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.eCommerceRoot,
            children: [
              {
                path: paths.orderDetails,
                element: (
                  <ProtectedChildren>
                    <OrderDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.orderList,
                element: (
                  <ProtectedChildren>
                    <Orders />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.customers,
                element: (
                  <ProtectedChildren>
                    <Customers />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.customerDetails,
                element: (
                  <ProtectedChildren>
                    <CustomersDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.shoppingCart,
                element: (
                  <ProtectedChildren>
                    <ShoppingCart />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.checkout,
                element: (
                  <ProtectedChildren>
                    <Checkout />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.billing,
                element: (
                  <ProtectedChildren>
                    <Billing />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.invoice,
                element: (
                  <ProtectedChildren>
                    <Invoice />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.addProduct,
                element: (
                  <ProtectedChildren>
                    <AddProduct />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.products(':productLayout'),
                element: (
                  <ProtectedChildren>
                    <Products />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.productDetails(':productId'),
                element: (
                  <ProtectedChildren>
                    <ProductDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.productDetails(),
                element: (
                  <ProtectedChildren>
                    <ProductDetails />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.eLearningRoot,
            children: [
              {
                path: paths.courses(':courseLayout'),
                element: (
                  <ProtectedChildren>
                    <Courses />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.courseDetails(),
                element: (
                  <ProtectedChildren>
                    <CourseDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.createCourse,
                element: (
                  <ProtectedChildren>
                    <CreateCourse />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.courseDetails(':courseId'),
                element: (
                  <ProtectedChildren>
                    <CourseDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.studentOverview,
                element: (
                  <ProtectedChildren>
                    <StudentOverview />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.trainerProfile,
                element: (
                  <ProtectedChildren>
                    <TrainerProfile />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.supportDeskRoot,
            children: [
              {
                path: paths.ticketsTable,
                element: (
                  <ProtectedChildren>
                    <TableView />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.ticketsCard,
                element: (
                  <ProtectedChildren>
                    <CardView />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.contacts,
                element: (
                  <ProtectedChildren>
                    <Contacts />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.contactDetails,
                element: (
                  <ProtectedChildren>
                    <ContactDetails />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.ticketsPreview,
                element: (
                  <ProtectedChildren>
                    <TicketsPreview />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.quickLinks,
                element: (
                  <ProtectedChildren>
                    <QuickLinks />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.reports,
                element: (
                  <ProtectedChildren>
                    <Reports />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.pagesRoot,
            children: [
              {
                path: paths.starter,
                element: (
                  <ProtectedChildren>
                    <Starter />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.userRoot,
            children: [
              {
                path: paths.userProfile,
                element: (
                  <ProtectedChildren>
                    <Profile />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.userSettings,
                element: (
                  <ProtectedChildren>
                    <Settings />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.pricingRoot,
            children: [
              {
                path: paths.pricingDefault,
                element: (
                  <ProtectedChildren>
                    <PricingDefault />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.pricingAlt,
                element: (
                  <ProtectedChildren>
                    <PricingAlt />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.faqRoot,
            children: [
              {
                path: paths.faqBasic,
                element: (
                  <ProtectedChildren>
                    <FaqBasic />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.faqAlt,
                element: (
                  <ProtectedChildren>
                    <FaqAlt />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.faqAccordion,
                element: (
                  <ProtectedChildren>
                    <FaqAccordion />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.miscRoot,
            children: [
              {
                path: paths.associations,
                element: (
                  <ProtectedChildren>
                    <Associations />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.invitePeople,
                element: (
                  <ProtectedChildren>
                    <InvitePeople />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.privacyPolicy,
                element: (
                  <ProtectedChildren>
                    <PrivacyPolicy />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.formsRoot,
            children: [
              {
                path: rootPaths.basicFormsRoot,
                children: [
                  {
                    path: paths.formControl,
                    element: (
                      <ProtectedChildren>
                        <FormControl />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.inputGroup,
                    element: (
                      <ProtectedChildren>
                        <InputGroup />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.select,
                    element: (
                      <ProtectedChildren>
                        <Select />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.checks,
                    element: (
                      <ProtectedChildren>
                        <Checks />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.range,
                    element: (
                      <ProtectedChildren>
                        <Range />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.formLayout,
                    element: (
                      <ProtectedChildren>
                        <FormLayout />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
              {
                path: rootPaths.advanceFormsRoot,
                children: [
                  {
                    path: paths.advanceSelect,
                    element: (
                      <ProtectedChildren>
                        <AdvanceSelect />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.datePicker,
                    element: (
                      <ProtectedChildren>
                        <DatePicker />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.editor,
                    element: (
                      <ProtectedChildren>
                        <Editor />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.emojiButton,
                    element: (
                      <ProtectedChildren>
                        <EmojiMartExample />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.fileUploader,
                    element: (
                      <ProtectedChildren>
                        <FileUploader />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.inputMask,
                    element: (
                      <ProtectedChildren>
                        <InputMaskExample />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.rangeSlider,
                    element: (
                      <ProtectedChildren>
                        <RangeSlider />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.rating,
                    element: (
                      <ProtectedChildren>
                        <Rating />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
              {
                path: paths.floatingLabels,
                element: (
                  <ProtectedChildren>
                    <FloatingLabels />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.wizard,
                element: (
                  <ProtectedChildren>
                    <WizardForms />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.validation,
                element: (
                  <ProtectedChildren>
                    <FormValidation />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.tableRoot,
            children: [
              {
                path: paths.basicTables,
                element: (
                  <ProtectedChildren>
                    <Tables />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.advanceTables,
                element: (
                  <ProtectedChildren>
                    <AdvanceTableExamples />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.chartsRoot,
            children: [
              {
                path: paths.chartjs,
                element: (
                  <ProtectedChildren>
                    <Chartjs />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.d3js,
                element: (
                  <ProtectedChildren>
                    <D3js />
                  </ProtectedChildren>
                ),
              },
              {
                path: rootPaths.echartsRoot,
                children: [
                  {
                    path: paths.echartsHowToUse,
                    element: (
                      <ProtectedChildren>
                        <HowToUse />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.lineCharts,
                    element: (
                      <ProtectedChildren>
                        <LineCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.barCharts,
                    element: (
                      <ProtectedChildren>
                        <BarCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.candlestickCharts,
                    element: (
                      <ProtectedChildren>
                        <CandlestickCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.geoMap,
                    element: (
                      <ProtectedChildren>
                        <GeoMaps />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.scatterCharts,
                    element: (
                      <ProtectedChildren>
                        <ScatterCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.pieCharts,
                    element: (
                      <ProtectedChildren>
                        <PieCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.radarCharts,
                    element: (
                      <ProtectedChildren>
                        <RadarCharts />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.heatmapCharts,
                    element: (
                      <ProtectedChildren>
                        <HeatmapCharts />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: rootPaths.iconsRoot,
            children: [
              {
                path: paths.fontAwesome,
                element: (
                  <ProtectedChildren>
                    <FontAwesome />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.reactIcons,
                element: (
                  <ProtectedChildren>
                    <ReactIcons />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.mapsRoot,
            children: [
              {
                path: paths.googleMap,
                element: (
                  <ProtectedChildren>
                    <GoogleMapExample />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.leafletMap,
                element: (
                  <ProtectedChildren>
                    <LeafletMapExample />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.componentsRoot,
            children: [
              {
                path: paths.alerts,
                element: (
                  <ProtectedChildren>
                    <Alerts />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.accordion,
                element: (
                  <ProtectedChildren>
                    <Accordion />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.animatedIcons,
                element: (
                  <ProtectedChildren>
                    <AnimatedIcons />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.background,
                element: (
                  <ProtectedChildren>
                    <Backgrounds />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.badges,
                element: (
                  <ProtectedChildren>
                    <Badges />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.breadcrumbs,
                element: (
                  <ProtectedChildren>
                    <Breadcrumbs />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.buttons,
                element: (
                  <ProtectedChildren>
                    <Buttons />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.calendarExample,
                element: (
                  <ProtectedChildren>
                    <CalendarExample />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cards,
                element: (
                  <ProtectedChildren>
                    <Cards />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cards,
                element: (
                  <ProtectedChildren>
                    <Cards />
                  </ProtectedChildren>
                ),
              },
              {
                path: rootPaths.carouselRoot,
                children: [
                  {
                    path: paths.bootstrapCarousel,
                    element: (
                      <ProtectedChildren>
                        <BootstrapCarousel />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.slickCarousel,
                    element: (
                      <ProtectedChildren>
                        <SlickCarousel />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
              {
                path: paths.collapse,
                element: (
                  <ProtectedChildren>
                    <Collapse />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.cookieNotice,
                element: (
                  <ProtectedChildren>
                    <CookieNoticeExample />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.countup,
                element: (
                  <ProtectedChildren>
                    <CountUp />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.draggable,
                element: (
                  <ProtectedChildren>
                    <DraggableExample />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.dropdowns,
                element: (
                  <ProtectedChildren>
                    <Dropdowns />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.listGroup,
                element: (
                  <ProtectedChildren>
                    <ListGroups />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.modals,
                element: (
                  <ProtectedChildren>
                    <Modals />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.offcanvas,
                element: (
                  <ProtectedChildren>
                    <Offcanvas />
                  </ProtectedChildren>
                ),
              },
              {
                path: rootPaths.navsAndTabsRoot,
                children: [
                  {
                    path: paths.navs,
                    element: (
                      <ProtectedChildren>
                        <Navs />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.navbar,
                    element: (
                      <ProtectedChildren>
                        <Navbars />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.verticalNavbar,
                    element: (
                      <ProtectedChildren>
                        <VerticalNavbar />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.topNavbar,
                    element: (
                      <ProtectedChildren>
                        <NavBarTop />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.doubleTopNavbar,
                    element: (
                      <ProtectedChildren>
                        <NavbarDoubleTop />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.comboNavbar,
                    element: (
                      <ProtectedChildren>
                        <ComboNavbar />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.tabs,
                    element: (
                      <ProtectedChildren>
                        <Tabs />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
              {
                path: rootPaths.picturesRoot,
                children: [
                  {
                    path: paths.avatar,
                    element: (
                      <ProtectedChildren>
                        <Avatar />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.images,
                    element: (
                      <ProtectedChildren>
                        <Image />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.figures,
                    element: (
                      <ProtectedChildren>
                        <Figures />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.hoverbox,
                    element: (
                      <ProtectedChildren>
                        <Hoverbox />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.lightbox,
                    element: (
                      <ProtectedChildren>
                        <Lightbox />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
              {
                path: paths.progressBar,
                element: (
                  <ProtectedChildren>
                    <BasicProgressBar />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.pagination,
                element: (
                  <ProtectedChildren>
                    <Pagination />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.placeholder,
                element: (
                  <ProtectedChildren>
                    <Placeholder />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.popovers,
                element: (
                  <ProtectedChildren>
                    <Popovers />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.scrollspy,
                element: (
                  <ProtectedChildren>
                    <Scrollspy />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.search,
                element: (
                  <ProtectedChildren>
                    <Search />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.spinners,
                element: (
                  <ProtectedChildren>
                    <Spinners />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.timeline,
                element: (
                  <ProtectedChildren>
                    <Timeline />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.toasts,
                element: (
                  <ProtectedChildren>
                    <Toasts />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.tooltips,
                element: (
                  <ProtectedChildren>
                    <Tooltips />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.treeview,
                element: (
                  <ProtectedChildren>
                    <TreeviewExample />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.typedText,
                element: (
                  <ProtectedChildren>
                    <TypedText />
                  </ProtectedChildren>
                ),
              },
              {
                path: rootPaths.videosRoot,
                children: [
                  {
                    path: paths.embedVideo,
                    element: (
                      <ProtectedChildren>
                        <Embed />
                      </ProtectedChildren>
                    ),
                  },
                  {
                    path: paths.reactPlayer,
                    element: (
                      <ProtectedChildren>
                        <ReactPlayerExample />
                      </ProtectedChildren>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: rootPaths.utilitiesRoot,
            children: [
              {
                path: paths.backgroundColor,
                element: (
                  <ProtectedChildren>
                    <Background />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.borders,
                element: (
                  <ProtectedChildren>
                    <Borders />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.colors,
                element: (
                  <ProtectedChildren>
                    <Colors />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.coloredLinks,
                element: (
                  <ProtectedChildren>
                    <ColoredLinks />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.display,
                element: (
                  <ProtectedChildren>
                    <Display />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.flex,
                element: (
                  <ProtectedChildren>
                    <Flex />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.float,
                element: (
                  <ProtectedChildren>
                    <Float />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.grid,
                element: (
                  <ProtectedChildren>
                    <Grid />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.scrollBar,
                element: (
                  <ProtectedChildren>
                    <Scrollbar />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.position,
                element: (
                  <ProtectedChildren>
                    <Position />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.spacing,
                element: (
                  <ProtectedChildren>
                    <Spacing />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.sizing,
                element: (
                  <ProtectedChildren>
                    <Sizing />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.stretchedLink,
                element: (
                  <ProtectedChildren>
                    <StretchedLink />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.textTruncation,
                element: (
                  <ProtectedChildren>
                    <TextTruncation />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.typography,
                element: (
                  <ProtectedChildren>
                    <Typography />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.verticalAlign,
                element: (
                  <ProtectedChildren>
                    <VerticalAlign />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.visibility,
                element: (
                  <ProtectedChildren>
                    <Visibility />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: rootPaths.docRoot,
            children: [
              {
                path: paths.gettingStarted,
                element: (
                  <ProtectedChildren>
                    <GettingStarted />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.configuration,
                element: (
                  <ProtectedChildren>
                    <Configuration />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.styling,
                element: (
                  <ProtectedChildren>
                    <Styling />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.darkMode,
                element: (
                  <ProtectedChildren>
                    <DarkMode />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.plugin,
                element: (
                  <ProtectedChildren>
                    <Plugins />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.faq,
                element: (
                  <ProtectedChildren>
                    <Faq />
                  </ProtectedChildren>
                ),
              },
              {
                path: paths.designFile,
                element: (
                  <ProtectedChildren>
                    <DesignFile />
                  </ProtectedChildren>
                ),
              },
            ],
          },
          {
            path: paths.widgets,
            element: (
              <ProtectedChildren>
                <Widgets />
              </ProtectedChildren>
            ),
          },
          {
            path: paths.changelog,
            element: (
              <ProtectedChildren>
                <Changelog />
              </ProtectedChildren>
            ),
          },
        ],
      },
      {
        path: '/',
        element: (
          <ProtectedChildren>
            <VerticalNavLayout />
          </ProtectedChildren>
        ),
        children: [
          {
            path: paths.verticalNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: '/',
        element: (
          <ProtectedChildren>
            <TopNavLayout />
          </ProtectedChildren>
        ),
        children: [
          {
            path: paths.topNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: '/',
        element: (
          <ProtectedChildren>
            <ComboNavLayout />
          </ProtectedChildren>
        ),
        children: [
          {
            path: paths.comboNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: '/',
        element: <DoubleTopNavLayout />,
        children: [
          {
            path: paths.doubleTopNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to={paths.error404} replace />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

export default routes;
